import { addS3Url } from "../../utils/modules";
import { IMAGE_LOADED } from "../types/image/image";

export const setImageLoaded = (imagePath) => ({
  type: IMAGE_LOADED,
  payload: imagePath,
});

export const preLoadImage = (images) => {
  return async (dispatch, getState) => {
    const state = getState();

    const imagePromises = images.map((src) => {
      if (!state.images[src]) {
        return new Promise((resolve, reject) => {
          const img = new Image();
          img.src = addS3Url(src);
          img.onload = () => {
            dispatch(setImageLoaded(src));
            resolve();
          };
          img.onerror = (error) => {
            console.error("Error loading image from S3:", src, error);
            reject(error);
          };
        });
      }
      return Promise.resolve();
    });

    try {
      await Promise.all(imagePromises);
    } catch (error) {
      console.error("Error in initialLoadImage:", error);
    }
  };
};

export const initialLoadImage = () => {
  return async (dispatch, getState) => {
    const state = getState();
    const images = Object.keys(state.images);

    const imagePromises = images.map((src) => {
      if (!state.images[src]) {
        return new Promise((resolve, reject) => {
          const img = new Image();
          img.src = addS3Url(src);
          img.onload = () => {
            dispatch(setImageLoaded(src));
            resolve();
          };
          img.onerror = (error) => {
            console.error("Error loading image from S3:", src, error);
            reject(error);
          };
        });
      }
      return Promise.resolve();
    });

    try {
      await Promise.all(imagePromises);
    } catch (error) {
      console.error("Error in initialLoadImage:", error);
    }
  };
};
